var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backstage"},[_c('navigator',{attrs:{"title":_vm.navtital}}),_vm._v(" "),_c('mt-button',{staticClass:"myButton",attrs:{"type":"danger"},on:{"click":function($event){_vm.toModule("/personal")}}},[_vm._v("个人中心")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cc6ebd8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backstage/Backstage.vue
// module id = null
// module chunks = 